import Gedoc from "../";

const routes = [
    { name: "GedocProtocolliList", path: "/gedocprotocollinotification", component: Gedoc.GedocProtocolliList, meta: { title: "Gedoc Notification" } },
    { name: "GedocProtocolloView", path: "/gedocprotocollo/view/:id", component: Gedoc.GedocProtocolloView, meta: { title: "Gedoc Notification" } }                                                         
];

export default routes;